import { performLogin } from 'app-redux/actions/login.actions';
import { history, RoutePaths } from 'core/history';
import { INavigationRouteProps } from 'core/navigation/models';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SegmentService } from 'services/SegmentService';
import { translationWrapper } from 'utils/common-methods';
import { initMfesAccountsManagement } from 'index';

interface ILoginProps extends INavigationRouteProps<{}> {
  performLogin: (code: string) => Promise<{}>;
}

const AuthenticationRedirect: React.FC<ILoginProps> = (props) => {
  const [display, setDisplay] = useState('Loading...');
  const code = new URLSearchParams(props.location.search).get('code') || '';
  const state = new URLSearchParams(props.location.search).get('state');
  const { t } = translationWrapper(useTranslation(), false);
  useEffect(() => {
    const loginAndRedirect = async () => {
      // loads mfes when loging in, as the /app/authenticate page is a public page, and, as such, does not load the mfes as a standard
      await initMfesAccountsManagement()
      return props.performLogin(code);
    };

    loginAndRedirect().then(() => {
      SegmentService().identify('');
      if (state) {
        setDisplay('Redirecting you to the application...');
        try {
          const newPath = atob(state);
          if (newPath.startsWith('/')) {
            history.replace(newPath);
          } else {
            history.replace(RoutePaths.HOME());
          }
        } catch (ex) {
          history.replace(RoutePaths.HOME());
        }
      } else {
        history.replace(RoutePaths.HOME());
      }
    }).catch(() => {
      setDisplay('Error authenticating user...');
      history.replace(RoutePaths.HOME());
    });
  }, []);

  return (
        <div
          style={{ textAlign: 'center', marginTop: '80px' }}
        >
            {t(display)}
        </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: any) => {
  return {
    performLogin: (code: string) => dispatch(performLogin(code)),
  };
};

export const AuthenticationRedirectComponent = withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthenticationRedirect));
